import { Button, Divider, Flex, Form, Select, Space, Table } from 'antd';
import { useEffect, useMemo, useRef, useState } from 'react';
import { apiBasePath } from '../../../utils/constants';
import axios from 'axios';
import { normalizeClientData, normalizeClientDataForExport } from './normalize';
import { ClientForm } from './clientsForm';
import { ActiveColumn } from '../../common/tableCustomColumns';
import { ButtonExportData } from '../../common';

export const ClientsManagement = () => {
  const [loader, setLoader] = useState(false);
  const [clientList, setClientList] = useState([]);
  const [columns, setColumns] = useState([]);
  const [form] = Form.useForm();
  const [dataFilter, setDataFilter] = useState(null);
  const [openClientForm, setOpenClientForm] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [exportData, setExportData] = useState([]);
  const wasEditedRef = useRef(false);

  const getClientList = async () => {
    setLoader(true);
    try {
      const responseClientList = await axios.get(`${apiBasePath}/customer`);
      const { lstCustomer } = responseClientList.data;
      setDataFilter(lstCustomer);
      const { dataSource, columns } = normalizeClientData(lstCustomer);
      const exportData = normalizeClientDataForExport(lstCustomer);
      setExportData(exportData);
      setClientList(dataSource);
      setColumns(columns);
    } catch (e) {
      console.error('🚀 ~ getFiltersData ~ e:', e);
    } finally {
      setLoader(false);
    }
  };
  const getFilterClientList = async (cliId) => {
    if (!cliId) {
      getClientList();
      return;
    }
    setLoader(true);
    try {
      const responseClientList = await axios.get(`${apiBasePath}/customer/id/${cliId}`);
      const { customer } = responseClientList.data;
      const { dataSource, columns } = normalizeClientData([customer]);
      const exportData = normalizeClientDataForExport([customer]);
      setExportData(exportData);
      setClientList(dataSource);
      setColumns(columns);
    } catch (e) {
      console.error('🚀 ~ getFilterClientList ~ e:', e);
    } finally {
      setLoader(false);
    }
  };
  const editClient = (cliData) => {
    setOpenClientForm(true);
    setSelectedClient(cliData);
  };

  useEffect(() => {
    getClientList();
  }, []);

  const columnsTable = useMemo(() => [...(columns ?? []), ActiveColumn], [columns]);

  return (
    <div className="basic-layout">
      <Flex justify="space-between" align="center" className="basic-layout-header">
        <h1>Listado de Clientes</h1>
        <Space>
          <Form form={form}>
            <Form.Item
              name="filterClients"
              label="Buscar Cliente"
              labelAlign="left"
              layout="vertical"
              style={{ width: '500px' }}>
              <Select
                loading={loader}
                allowClear
                showSearch
                defaultValue={0}
                onChange={(value) => getFilterClientList(value)}
                filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}>
                <Select.Option key={'all_clients'} value={0} label={'todos'}>
                  {'Todos'}
                </Select.Option>
                {dataFilter?.map((customer) => (
                  <Select.Option
                    key={customer.clie_id}
                    value={customer.clie_id}
                    label={`${customer.clie_id} - ${customer.clie_rfc} - ${customer.clie_nombre} ${customer.clie_ap} ${customer.clie_am} - ${customer.clie_correo}`}>
                    {`${customer.clie_rfc} - ${customer.clie_nombre} ${customer.clie_ap} ${customer.clie_am}`}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Form>
          <Button
            type="primary"
            onClick={() => {
              setOpenClientForm(true);
              setSelectedClient(null);
            }}>
            Agregar Cliente
          </Button>
        </Space>
      </Flex>
      <Divider />
      <Flex justify="end" style={{ marginBottom: '1rem' }}>
        <ButtonExportData jsonData={exportData} fileName="Clientes" />
      </Flex>
      <Table
        dataSource={clientList}
        columns={columnsTable}
        style={{ cursor: 'pointer' }}
        loading={loader}
        onRow={(record) => ({ onClick: () => editClient(record) })}
      />
      <ClientForm
        open={openClientForm}
        selectedClient={selectedClient}
        setWasEdited={wasEditedRef}
        onClose={() => {
          setOpenClientForm(false);
          setSelectedClient(null);
          if (wasEditedRef.current) {
            getClientList();
            form.setFieldsValue({ filterClients: 0 });
          }
          wasEditedRef.current = false;
        }}
      />
    </div>
  );
};
